module.exports = __webpack_public_path__ + "static/media/techLead.881a3454.jpeg";